import React from 'react'
import styles from './LinearProgress.module.scss'

export default ({ className }) => (
  <div className={`${styles.progress} ${className || ''}`}></div>
)